import StudyData from './StudyData';

export default StudyData;
